import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IApp03Project } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';
import { App03Frameworks } from '../types/App03Workflow';

export class App03ProjectService extends EntityWithStatusService<IApp03Project> {
    protected childrenEntities = ['Contributors($expand=ContributorUser)', 'CustomFields($expand=CustomFieldDfn)'];

    constructor() {
        super(`/App03Projects`);
    }

    public readAllForList(includeClosed?: boolean, frameworkID?: App03Frameworks, portfolioID?: number): Promise<IApp03Project[]> {
        return this.readAll(
            `?$select=ID,Title,ProjectTypeID,App03ProjectTypeID`
            + `&$orderby=Title`
            + `&$expand=`
            + `Portfolio($select=Title),OwnerUser($select=Title)`
            //+ `Portfolio($select=Title),Contributors($expand=ContributorUser($select=Title))`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (portfolioID ? ` and PortfolioID eq ${portfolioID}` : '')
        );
    }

    public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<IApp03Project[]> {
        return this.readAll(
            `?$select=ID,Title,FrameworkID${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosedEntities ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async readTitleForProject(entityPlural: string, entitySingular: string, projectID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            DescriptionLine1: '',
            DescriptionLine2: '',
            Description1ForList: '',
            Description1ForForm: ''
        };
        const res = await this.readAll(`?$filter=ID eq ${projectID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for project`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for project <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for project <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public countAllForList(frameworkID: App03Frameworks): Promise<IApp03Project[]> {
        return this.readAll(
            `?$select=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID} and EntityStatusID eq ${EntityStatus.Open}`
        );
    }

    public async countProjectsForPortfolio(portfolioID: number): Promise<number> {
        if (portfolioID) {
            return (await this.readAll(`?$select=ID&$filter=EntityStatusID eq ${EntityStatus.Open} and PortfolioID eq ${portfolioID}`))?.length;
        }
        return Promise.resolve(0);
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        return this.entityChildrenSingle(id, 'Workstreams', 'App03Workflows', true);
    }


}